// Common utility functions for styling used across cashflow components

export const getIndentClass = (level) => {
    switch (level) {
        case 0:
            return '!tw-pl-2';
        case 1:
            return '!tw-pl-4';
        case 2:
            return '!tw-pl-8';
        case 3:
            return '!tw-pl-12';
        case 4:
            return '!tw-pl-16';
        case 5:
            return '!tw-pl-20';
        case 6:
            return '!tw-pl-24';
        case 7:
            return '!tw-pl-26';
        default:
            return '!tw-pl-2';
    }
};

export const getBgClass = (level, type = 'default') => {
    switch (type) {
        case 'department':
            return '!tw-bg-blue-25';
        case 'expense':
            switch (level) {
                case 0:
                    return '!tw-bg-orange-50';
                case 1:
                    return '!tw-bg-gray-50';
                case 2:
                    return '!tw-bg-gray-25';
                case 3:
                case 4:
                    return '!tw-bg-gray-75';
                default:
                    return '!tw-bg-white';
            }
        case 'revenue':
            switch (level) {
                case 0:
                    return '!tw-bg-amber-50';
                case 1:
                    return '!tw-bg-gray-50';
                case 2:
                    return '!tw-bg-gray-25';
                default:
                    return '!tw-bg-gray-50';
            }
        case 'sponsor':
            switch (level) {
                case 0:
                    return '!tw-bg-green-50';
                case 1:
                    return '!tw-bg-gray-50';
                case 2:
                    return '!tw-bg-gray-25';
                default:
                    return '!tw-bg-gray-50';
            }
        default:
            return '!tw-bg-gray-50';
    }
};

export const getTextClass = (level, isCommitted = false) => {
    if (level > 2 && isCommitted) {
        return '!tw-font-bold';
    }
    return '';
};
